import {Breadcrumb, Button} from "antd";
import {HasAccess} from "@permify/react-role";
import {useState} from "react";
import { HomeOutlined, PlusOutlined, EyeOutlined, EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import ActionsMenu from "../../components/actionsMenu";
import ShowDocument from "./show";
import AddPublication from "./add";
import DataTable from "../../components/dataTable";

const Publications = () => {
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const [id, setId] = useState(null);
    const [editId, setEditId] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleRefresh = () => {
        setRefreshTrigger((prev) => prev + 1);
    };

    const handleAddSuccess = () => {
        setAddModal(false);
        handleRefresh();
    };

    const handleEditSuccess = () => {
        setEditModal(false);
        handleRefresh();
    };

    const columns = [
        {
            key: "type",
            dataIndex: ["type", "label"],
            title: "Type de publication",
        },
        {
            key: "title",
            dataIndex: "title",
            title: "Titre",
        },
        {
            key: "created_at",
            dataIndex: "created_at",
            title: "Date de création",
            render: (created_at) =>
                dayjs(created_at).format("DD/MM/YYYY à HH:mm:ss"),
        },
        {
            title: "",
            width: "150px",
            render: (_, record) => (
                <ActionsMenu
                    actions={[
                        {
                            key: "view",
                            label: "Voir les détails",
                            icon: <EyeOutlined />,
                            permission: "read_publications",
                            onClick: () => {
                                setId(record.id);
                                setShowModal(true);
                            },
                        },
                        {
                            key: "edit",
                            label: "Modifier",
                            icon: <EditOutlined />,
                            permission: "update_publications",
                            onClick: () => {
                                setEditId(record.id);
                                setEditModal(true);
                            },
                        },
                    ]}
                />
            ),
        },
    ];

    return (
        <>
            <HasAccess permissions="create_publications">
                <AddPublication
                    open={addModal}
                    setOpen={setAddModal}
                    onSuccess={handleAddSuccess}
                />
            </HasAccess>

            <HasAccess permissions="update_publications">
                <AddPublication
                    id={editId}
                    open={editModal}
                    setOpen={setEditModal}
                    onSuccess={handleEditSuccess}
                />
            </HasAccess>

            <HasAccess permissions="read_publications">
                <ShowDocument
                    id={id}
                    open={showModal}
                    setOpen={setShowModal}
                />
            </HasAccess>

            <div className="flex flex-row mt-8">
                <Breadcrumb>
                    <Breadcrumb.Item href="/">
                        <HomeOutlined />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                        Publications
                    </Breadcrumb.Item>
                </Breadcrumb>

                <div className="ml-auto">
                    <HasAccess permissions="create_publications">
                        <Button
                            icon={<PlusOutlined />}
                            onClick={() => setAddModal(true)}
                            type="primary"
                        >
                            Ajouter une publication
                        </Button>
                    </HasAccess>
                </div>
            </div>

            <DataTable
                url="/client/publications"
                columns={columns}
                refreshTrigger={refreshTrigger}
            />
        </>
    );
};

export default Publications;
